import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab", "buttonContainer"]

    connect() {
        if (document.body.offsetWidth > 768) {
            this.setContainerMaxHeight();
        }
    }

    setContainerMaxHeight() {
        let maxHeight = 0;

        this.tabTargets.forEach(element => {
            const isHidden = element.classList.contains("hidden");
            if (isHidden) {
                element.classList.remove("hidden");
            }
            let height = element.clientHeight;
            if (isHidden) {
                element.classList.add("hidden");
            }
            if (height > maxHeight) { maxHeight = height; }
        });

        const reviewDetails = this.element.querySelector(".review-details");
        const containerPadding = window.getComputedStyle(this.element.querySelector("div")).padding.replace("px", "");
        const headingHeight = 30;

        const minHeight = maxHeight + headingHeight + this.buttonContainerTarget.clientHeight + containerPadding * 2 + (reviewDetails ? reviewDetails.clientHeight : 0) + 2;

        this.element.style.minHeight = `${minHeight}px`;
    }
}